import moment from "moment";
import Accordion, { EmptyStateMessage } from "../../components/Accordion"
import { BulletTabs } from "../../components/BulletTabs"
import { AssistancePlanContextContainer } from "../../container/AssistancePlanContextContainer"
import './styles.scss';
import { isMobile } from "react-device-detect";
import { LoadingWithLabel } from "../../components/Loading";

const tabs = [
  { value: 1, label: "Abertos", type: 'open' },
  // { value: 2, label: "Rascunhos", type: 'draft' },
  { value: 3, label: "Agendados", type: 'schedule' },
  { value: 4, label: "Fechados", type: 'closed' },
]

const AccordionHeader = ({ title, indicatorValue, date, currentTab, closedDate }) => {

  let description;
  if (currentTab && currentTab === 'open') {
    description = 'Iniciado em: '
  } else if (currentTab === 'schedule') {
    description = 'Agendado para: '
  } else if (currentTab === 'closed') {
    description = 'Finalizado em: '
  } else {
    description = 'Agendado para: '
  }
  return (
    <>
      <div className="plan-accordion__header" key={`${indicatorValue}-header`}>
        <span className="indicator-title">{title}</span>
        <span className="indicator-date">
          {currentTab === 'closed' ? (
            <>
              {!isMobile && (
                <>
                  Data: <span>{moment.utc(date).format('DD/MM/YYYY')}</span>
                  {" | "}
                </>
              )}
              {isMobile ? "" : description} <span>{moment.utc(closedDate).format('DD/MM/YYYY')}</span>
            </>
          ) : (
            <>
              {isMobile ? "" : description} <span>{moment.utc(date).format('DD/MM/YYYY')}</span>
            </>
          )
          }
        </span>
      </div>
    </>
  )
}

export const AssistancePlanScreen = ({
  currentOpen,
  handleActive,
  handleSaveDraft,
  handleOpenLinkMessage,
  onlyForm,
  pinnedMessagesQuestion,
  farmerDetails,
  resetFarmerProfile,
  handleChangeTab,
  isLoadingAssistances,
  data,
  contextDetails,
  currentTab,
  defaultAnswers,
  setDefaultAnswers,
  handleChangeSelectedProject,
  selectedProject,
  formQuestionMessage
}) => {

  if (currentOpen) {
    return <AssistancePlanContextContainer
      assistanceId={currentOpen}
      {...{
        pinnedMessagesQuestion,
        onlyForm,
        handleSaveDraft,
        handleOpenLinkMessage,
        formQuestionMessage,
        farmerDetails,
        resetFarmerProfile,
        contextDetails,
        defaultAnswers,
        setDefaultAnswers,
        handleChangeSelectedProject,
        selectedProject
      }}
    />
  }

  let description;
  let title;
  if (currentTab && currentTab === 'open') {
    description = 'Iniciado em'
    title = 'Atendimentos abertos'
  } else if (currentTab === 'schedule') {
    description = 'Agendado para'
    title = 'Atendimentos agendados'
  } else if (currentTab === 'closed') {
    description = 'Finalizado em'
    title = 'Atendimentos finalizados'
  } else {
    description = 'Agendado para'
    title = 'Atendimentos agendados'
  }

  const normalizedTab = (currentTab || "").toLowerCase();

  let emptyMessage = "Nenhum atendimento finalizado registrado até o momento.";
  let emptyIcon = "fi fi-rr-check-double";


  if (normalizedTab.includes("aberto") || normalizedTab.includes("open")) {
    emptyMessage = "Nenhum atendimento em aberto no momento.";
    emptyIcon = "fi fi-rr-folder-open";
  } else if (normalizedTab.includes("agendado") || normalizedTab.includes("schedule")) {
    emptyMessage = "Nenhum atendimento agendado para este beneficiário.";
    emptyIcon = "fi fi-rr-calendar";
  }

  return (
    <div className="assitance-plan__container">
      <div className="bullet-tabs-sticky">
        <BulletTabs
          options={tabs}
          onSelect={handleChangeTab}
        />
      </div>
      <div className="plan__content">
        {isMobile && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span>{title}</span>
            <span>{description}</span>
          </div>
        )}

        {isLoadingAssistances ? (
          <div className="loading-spinner">
            <LoadingWithLabel labelLoading={`Buscando ${title}`} colorSpinner="primary" />
          </div>
        ) : Array.isArray(data) && data.length > 0 ? (
          data.map((row) => (
            <Accordion
              key={row?.id}
              index={row?.id}
              handleActive={(value) => handleActive({ ...value, ...row }, currentTab)}
              id={row?.id}
              title={row?.title}
              description={row?.description}
              header={
                <AccordionHeader
                  title={row?.title}
                  date={row?.dateToAdd}
                  indicatorValue={row?.id}
                  description={row?.description}
                  currentTab={currentTab}
                  closedDate={row?.updatedAt}
                />
              }
              isDisabled
            />
          ))
        ) : (
          <EmptyStateMessage message={emptyMessage} iconClass={emptyIcon} />
        )}
      </div>
    </div>
  )
}
